export type TextableInvitation = {
  name: string;
  phone: string | null;
  backup_phone?: string | null;
  submitted_phone?: string | null;
  token: string;
};

export function invitationPhone(invitation: Pick<TextableInvitation, 'phone' | 'submitted_phone'>): string | null {
  return invitation.phone?.trim() || invitation.submitted_phone?.trim() || null;
}

export function invitationPhones(invitation: Pick<TextableInvitation, 'phone' | 'backup_phone' | 'submitted_phone'>): Array<{ label: 'Mobile' | 'Backup mobile'; phone: string }> {
  const primary = invitationPhone(invitation);
  const backup = invitation.backup_phone?.trim() || null;
  const normalizedPrimary = primary?.replace(/\D/g, '') || '';
  const normalizedBackup = backup?.replace(/\D/g, '') || '';
  return [
    ...(primary ? [{ label: 'Mobile' as const, phone: primary }] : []),
    ...(backup && normalizedBackup !== normalizedPrimary ? [{ label: 'Backup mobile' as const, phone: backup }] : []),
  ];
}

export function invitationUrl(token: string, origin = window.location.origin): string {
  return `${origin.replace(/\/$/, '')}/r/${token}`;
}

export function invitationText(invitation: Pick<TextableInvitation, 'name' | 'token'>, origin?: string): string {
  return `Hi ${invitation.name}! You're invited to Jeff Morgan's surprise 70th birthday on Nov. 8. RSVP here: ${invitationUrl(invitation.token, origin)}\n\nPlease keep it a surprise! Questions? Reply to this text to reach me, JR Morgan, or use the contact form on the RSVP website.`;
}

export function reminderText(invitation: Pick<TextableInvitation, 'name' | 'token'>, origin?: string): string {
  return `Hi ${invitation.name}! In case this got lost somewhere between the panhandle and the Everglades: Jeff Morgan—the O.G. Florida Man—is turning 70 on Nov. 8. It's not too late—please RSVP soon: ${invitationUrl(invitation.token, origin)}\n\nPlease keep it a surprise! Questions? Reply to this text to reach me, JR Morgan, or use the contact form on the RSVP website.`;
}

export function smsHref(phone: string, message: string): string {
  const normalized = phone.trim().replace(/(?!^\+)\D/g, '');
  return `sms:${normalized}?body=${encodeURIComponent(message)}`;
}
